import SoftwareCard from "@/components/base/SoftwareCard";
import SectionHeader from "@/components/base/SectionHeader";
import { allSoftware, sortSoftware } from "@/utils/software";
import type { Software } from "@/utils/software";

interface Props {
  onDownload: (item: Software) => void;
}

const hot = sortSoftware(allSoftware, "downloads").slice(0, 6);

export default function HotSection({ onDownload }: Props) {
  return (
    <section>
      <SectionHeader
        icon="ri-fire-line"
        title="热门下载"
        desc="下载量与口碑双高的黄金投资工具"
        moreTo="/softwares"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3" data-product-shop>
        {hot.map((item) => (
          <SoftwareCard key={item.id} item={item} onDownload={onDownload} />
        ))}
      </div>
    </section>
  );
}